module.exports = __webpack_public_path__ + "img/pitch_play.878b61fd.jpg";